'use client';

import { c as _c } from "react/compiler-runtime";
import { formatFiatUnits, selectFundingAllowance } from '@morfi/onramp-sdk';
import type { FundingCheckout } from '@morfi/onramp-sdk/react';
import { useLocale, useTranslations } from 'next-intl';
import { type ReactNode, useEffect, useRef } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { TOAST_IDS } from '@/config/toast-ids';
import { logger } from '@/lib/telemetry/logger';
import { showToast } from '@/lib/ui/toast';
export function FundingLimitRecovery(t0) {
  const $ = _c(21);
  const {
    checkout
  } = t0;
  const t = useTranslations("onramp");
  const locale = useLocale();
  const review = checkout.state === "amount" ? checkout.preview.review : checkout.review;
  let t1;
  if ($[0] !== locale || $[1] !== review) {
    const allowance = review ? selectFundingAllowance(review.limits) : null;
    t1 = allowance && review ? formatFiatUnits(allowance.remainingUnits, review.estimate.decimals, review.estimate.currency, locale) : null;
    $[0] = locale;
    $[1] = review;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const maximum = t1;
  const {
    blocked,
    canVerify
  } = checkout.limitRecovery;
  let t2;
  let t3;
  if ($[3] !== blocked || $[4] !== canVerify || $[5] !== checkout.state) {
    t2 = () => {
      if (blocked) {
        logger.warn("onramp.allowance_blocked", {
          phase: checkout.state,
          verificationAvailable: canVerify
        });
      }
    };
    t3 = [blocked, canVerify, checkout.state];
    $[3] = blocked;
    $[4] = canVerify;
    $[5] = checkout.state;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  const announced = useRef(null);
  const notice = blocked ? `${canVerify}:${maximum}` : null;
  let t4;
  let t5;
  if ($[8] !== canVerify || $[9] !== maximum || $[10] !== notice || $[11] !== t) {
    t4 = () => {
      if (notice && notice !== announced.current) {
        showToast({
          id: TOAST_IDS.ONRAMP_ALLOWANCE,
          message: !canVerify && maximum ? t("allowance_maximum", {
            amount: maximum
          }) : t("allowance_blocked"),
          variant: "error"
        });
      }
      announced.current = notice;
    };
    t5 = [notice, canVerify, maximum, t];
    $[8] = canVerify;
    $[9] = maximum;
    $[10] = notice;
    $[11] = t;
    $[12] = t4;
    $[13] = t5;
  } else {
    t4 = $[12];
    t5 = $[13];
  }
  useEffect(t4, t5);
  if (!blocked || !canVerify) {
    return null;
  }
  let t6;
  if ($[14] !== canVerify || $[15] !== checkout.busy || $[16] !== checkout.verifyLimits || $[17] !== t) {
    t6 = canVerify ? <AnimatedButton variant="primary" className="h-11 w-full" loading={checkout.busy} disabled={checkout.busy} onClick={checkout.verifyLimits}>{t("allowance_complete_kyc")}</AnimatedButton> : null;
    $[14] = canVerify;
    $[15] = checkout.busy;
    $[16] = checkout.verifyLimits;
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t6) {
    t7 = <div className="flex flex-col gap-3">{t6}</div>;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}